module.exports = __webpack_public_path__ + "static/media/upload_blue.3470790f.svg";